<template>
  <div  id="NavCon" class="nav-con">
      <div id="Nav" class="nav">
        <a href="/"><div class="logo"></div></a>
        <ul class="nav-list">
            <li><router-link :to="{ name: 'Service'}" active-class="nav-router-link-active" exact>服务介绍</router-link></li>
            <li><router-link :to="{ name: 'Scene'}" active-class="nav-router-link-active">使用场景</router-link></li>
            <li><router-link :to="{ name: 'Flow'}" active-class="nav-router-link-active">接入流程</router-link></li>
            <li><router-link :to="{ name: 'ApiDoc'}" active-class="nav-router-link-active">API文档</router-link></li>
            <li class="contact-us"><router-link :to="{ name: 'Flow', params: { anchor:'contact' } }" active-class="nav-router-link-none">立即合作</router-link></li>
        </ul>
      </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalNav',
  mounted () {
    window.addEventListener('scroll', function () {
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      var nav = document.getElementById('NavCon')
      if (scrollTop > 68) {
        nav.classList.add('fixed-nav')
      } else {
        nav.classList.remove('fixed-nav')
      }
    })
  }
}
</script>

<style scoped>
.nav-con{
    background: #FFFFFF;
    box-shadow: 0 4px 6px 0 rgba(0,0,0,0.10);
    height: 68px;
}
.nav{
    height: 68px;
    max-width: 1024px;
    min-width: 960px;
    margin: 0 auto;
}
.fixed-nav{
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
}
.nav .logo{
    width: 242px;
    height: 42px;
    background: url("../assets/logo.png") 50% 50% no-repeat;
    float:left;
    margin: 13px 0 0 0;
}
.nav-list{
    float: right;
    height: 68px;
    overflow: hidden;
    font-size: 0;
    font-family: PingFangSC-Regular;
}
.nav-list li{
    height: 68px;
    line-height: 68px;
    display: inline-block;
    font-size: 16px;
    color: #666;
    letter-spacing: 0;
    vertical-align: top;
}
.nav-list li a{
    color: #666;
    display: block;
    height: 68px;
    line-height: 68px;
    text-align: center;
    padding: 0 18px;
}
.nav-list a.nav-router-link-active{
    background: #F44336;
    color: white;
}
.nav-list li.contact-us{
    margin-left: 32px;
}
.nav-list li.contact-us a{
    width: 118px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #F44336;
    border-radius: 4px;
    margin-top: 18px;
    color: #F64A4E;
    padding: 0;
}
.nav-list li.contact-us a:hover{
    border: 1px solid #F44336;
    background: #F44336;
    color: white;
}
@media only screen and (-moz-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2){
    .nav .logo{
        width: 242px;
        height: 42px;
        background: url("../assets/logo@2x.png") 50% 50% no-repeat;
        background-size: contain;
    }
}
</style>



// WEBPACK FOOTER //
// GlobalNav.vue?38f14aa5